<div class="grid-panel-container" [style.height.px]="HeightPx" [style.width.px]="WidthPx">
    <ng-content></ng-content>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/source/app/controls/components/panels/grid-panel/grid-panel.html